module.exports = __webpack_public_path__ + "static/img/4.de3adbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Seguro-Colectivo/4.png
// module id = IDVP
// module chunks = 0